import { render, staticRenderFns } from "./AudioBlock.vue?vue&type=template&id=11e4de62&"
import script from "./AudioBlock.vue?vue&type=script&lang=js&"
export * from "./AudioBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports